module.exports = __webpack_public_path__ + "static/media/warehouse.d0924a27.svg";